import {EpicRequestConfig} from './EpicAxiosTypes';

export function requestConfig(params: any): EpicRequestConfig {
    return params as EpicRequestConfig;
}
